import { useEffect } from 'react';

import { ModalWrapper } from '@braskai/ui-kit';

import { useBalanceStore } from '@/entities/balance';
import { useTrialPaywallPending } from '@/entities/user/trialPaywallVariant';

import { useTrialPaywallExperimentModalStore } from '../../model/useTrialPaywallExperimentModalStore';
import { TrialPaywallExperimentModal } from './TrialPaywallExperimentModal';

type TrialPaywallExperimentTriggerProps = {
  onSettled: () => void;
};

const TrialPaywallExperimentTrigger = ({ onSettled }: TrialPaywallExperimentTriggerProps) => {
  const open = useTrialPaywallExperimentModalStore((state) => state.open);
  const hasTrialPlan = useBalanceStore((state) => state.hasTrialPlan);
  const isBalanceLoaded = useBalanceStore((state) => state.isBalanceLoaded);

  useEffect(() => {
    if (!isBalanceLoaded) return;

    if (!hasTrialPlan) {
      onSettled();
      return;
    }

    open();
    onSettled();
  }, [hasTrialPlan, isBalanceLoaded, onSettled, open]);

  return null;
};

export const TrialPaywallExperiment = () => {
  const { isPending, markShown } = useTrialPaywallPending();

  return (
    <>
      {isPending && <TrialPaywallExperimentTrigger onSettled={markShown} />}
      <ModalWrapper hook={useTrialPaywallExperimentModalStore}>
        <TrialPaywallExperimentModal />
      </ModalWrapper>
    </>
  );
};
